import { BACKOFFICE_PRODUCER_CARD_CATEGORY, USER_PERMISSIONS } from '../../../constants/types';
import { validateUserRole } from '../../../utils/utils';

export const infoCards = ({ userRole, category, generatesSellerReports, producerId }) => {
  const teamCards = [
    {
      title: 'Crear usuario',
      text: 'Crea administradores o vendedores para la productora',
      link: `/backoffice/productoras/${producerId}/usuarios/crear`,
      icon: 'people-add',
      category: BACKOFFICE_PRODUCER_CARD_CATEGORY.TEAM,
      permissions: validateUserRole(userRole, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Crear múltiples vendedores',
      text: 'Crea múltiples vendedores para la productora',
      link: `/backoffice/productoras/${producerId}/usuarios/creacionMultiple`,
      icon: 'group',
      category: BACKOFFICE_PRODUCER_CARD_CATEGORY.TEAM,
      permissions: validateUserRole(userRole, USER_PERMISSIONS.ADMIN),
    },
    {
      title: 'Panel de usuarios',
      text: 'Mirá y editá administradores o vendedores de la productora',
      link: `/backoffice/productoras/${producerId}/usuarios`,
      icon: 'page-text',
      category: BACKOFFICE_PRODUCER_CARD_CATEGORY.TEAM,
      permissions: validateUserRole(userRole, USER_PERMISSIONS.ADMIN_WITH_READ_ONLY),
    },
    {
      title: 'Crear team leader',
      text: 'Crea team leaders para la productora',
      link: `/backoffice/productoras/${producerId}/teamLeaders/crear`,
      icon: 'crown',
      category: BACKOFFICE_PRODUCER_CARD_CATEGORY.TEAM,
      permissions: validateUserRole(userRole, USER_PERMISSIONS.ADMIN) && generatesSellerReports,
    },
    {
      title: 'Panel de team leaders',
      text: 'Mirá y editá team leaders de la productora',
      link: `/backoffice/productoras/${producerId}/teamLeaders`,
      icon: 'clipboard-2',
      category: BACKOFFICE_PRODUCER_CARD_CATEGORY.TEAM,
      permissions:
        validateUserRole(userRole, USER_PERMISSIONS.ADMIN_WITH_READ_ONLY) && generatesSellerReports,
    },
  ];

  switch (category) {
    case BACKOFFICE_PRODUCER_CARD_CATEGORY.TEAM:
      return teamCards;
    default:
      return [];
  }
};
